import Mapping from "./mapping.json";

const fieldNames = Mapping;

export function formatErrorMessage(errorObj, errVar) {
  let errorMessages = [];
  let subKeyErrors = {};
  let count = 1;
  let optionalVariable = errVar || Mapping;

  if (typeof errorObj.detail === "string") {
    errorMessages.push(errorObj.detail);
  }

  for (const key in errorObj) {
    if (key === "detail") continue;

    const value = errorObj[key];

    // Case: Array of strings (already handled)
    if (Array.isArray(value) && typeof value[0] === "string") {
      let formattedKey = optionalVariable[key] || key;
      errorMessages.push(`${count}. ${formattedKey} - ${value[0]}`);
      count++;
    }

    // ✅ NEW: Handle nested object like: { email: { email: "already in use" } }
    else if (
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value)
    ) {
      for (const innerKey in value) {
        let formattedKey = optionalVariable[innerKey] || innerKey;
        let message = value[innerKey];

        if (typeof message === "string") {
          errorMessages.push(`${count}. ${formattedKey} - ${message}`);
          count++;
        }
      }
    }

    // Case: Nested arrays of objects (existing logic)
    else if (
      Array.isArray(value) &&
      value.some((item) => typeof item === "object" && item !== null)
    ) {
      value.forEach((item, index) => {
        for (const subKey in item) {
          if (Array.isArray(item[subKey]) && item[subKey].length > 0) {
            let formattedSubKey = optionalVariable[subKey] || subKey;

            if (!subKeyErrors[formattedSubKey]) {
              subKeyErrors[formattedSubKey] = [];
            }
            item[subKey].forEach((error) => {
              subKeyErrors[formattedSubKey].push(error);
            });
          }
        }
      });

      for (const subKey in subKeyErrors) {
        errorMessages.push(`${count}. Items:`);
        subKeyErrors[subKey].forEach((error, idx) => {
          errorMessages.push(` S.No ${idx + 1}. ${subKey} -  ${error}`);
        });
        count++;
      }
    }
  }

  return errorMessages.join("\n");
}
